import React from 'react';
import PlantSVG from '../Plant/PlantSVG';
import { formatTime } from '../../utils/timeUtils';

export default function TimerActive({
  remaining,
  durationMs,
  progress,
  plantType = 'roma',
  tag = 'work',
  isWilting = false,
  onGiveUp,
}) {
  const timeStr = formatTime(remaining);
  const progressPercent = Math.round(progress * 100);

  return (
    <div
      role="main"
      aria-label="Active focus session"
      className="relative flex flex-col items-center justify-between min-h-[100dvh] px-4 py-4 max-w-md mx-auto"
    >
      <button
        type="button"
        onClick={onGiveUp}
        aria-label="Give up"
        className="absolute top-3 right-3 z-10 px-3 py-1.5 rounded-full text-xs font-medium text-[color:var(--color-text-muted)] bg-transparent hover:text-tomato-600 dark:hover:text-tomato-400 hover:bg-tomato-500/5 transition-colors"
      >
        Give up
      </button>

      {isWilting && (
        <div role="alert" className="mt-12 px-4 py-2 rounded-xl bg-amber-500/10 border border-amber-500/30 text-amber-600 dark:text-amber-400 text-sm font-semibold animate-pulse">
          Your plant is wilting! Stay on this page.
        </div>
      )}

      <div className="flex-1 flex items-center justify-center w-full">
        <PlantSVG
          species={plantType}
          progress={progress}
          isWilting={isWilting}
          size={Math.min(280, window.innerWidth * 0.65)}
        />
      </div>

      <div className="w-full space-y-3 pb-6">
        <div
          aria-live="polite"
          aria-atomic="true"
          className="text-center text-6xl font-bold tracking-tight tabular-nums bg-gradient-to-br from-[color:var(--color-text-primary)] to-[color:var(--color-accent-light)] bg-clip-text text-transparent"
        >
          {timeStr}
        </div>

        <div
          role="progressbar"
          aria-valuenow={progressPercent}
          aria-valuemin="0"
          aria-valuemax="100"
          className="h-1.5 rounded-full bg-[color:var(--color-bg-elevated)] overflow-hidden"
        >
          <div
            className="h-full rounded-full bg-gradient-to-r from-tomato-700 via-tomato-500 to-tomato-400 transition-[width] duration-1000"
            style={{ width: `${progressPercent}%` }}
          />
        </div>

        <div className="flex items-center justify-between text-xs">
          <span className="text-[color:var(--color-text-muted)]">
            {progressPercent < 25
              ? 'Planting seed...'
              : progressPercent < 50
                ? 'Sprouting...'
                : progressPercent < 75
                  ? 'Growing strong...'
                  : 'Almost there!'}
          </span>
          <span className="font-semibold text-[color:var(--color-accent-light)]">{progressPercent}%</span>
        </div>
      </div>
    </div>
  );
}
